export const BrandsIcon: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='18.414'
			height='18.414'
			className='brands-icon-svg'
			viewBox='0 0 18.414 18.414'>
			<g id='_001-mozy' data-name='001-mozy' transform='translate(0)'>
				<g id='Group_4572' data-name='Group 4572' transform='translate(0 0)'>
					<g id='Group_4571' data-name='Group 4571'>
						<path
							id='Path_3401'
							data-name='Path 3401'
							d='M5.587,0H2.524A2.527,2.527,0,0,0,0,2.524V5.587A2.527,2.527,0,0,0,2.524,8.112H5.587A2.527,2.527,0,0,0,8.112,5.587V2.524A2.527,2.527,0,0,0,5.587,0Z'
							fill='#3b2a82'
						/>
					</g>
				</g>
				<g
					id='Group_4574'
					data-name='Group 4574'
					transform='translate(10.302 10.302)'>
					<g id='Group_4573' data-name='Group 4573'>
						<path
							id='Path_3402'
							data-name='Path 3402'
							d='M276.587,271h-3.063A2.527,2.527,0,0,0,271,273.524v3.063a2.527,2.527,0,0,0,2.524,2.524h3.063a2.527,2.527,0,0,0,2.524-2.524v-3.063A2.527,2.527,0,0,0,276.587,271Z'
							transform='translate(-271 -271)'
							fill='#3b2a82'
						/>
					</g>
				</g>
				<g
					id='Group_4576'
					data-name='Group 4576'
					transform='translate(0.59 0.59)'>
					<g id='Group_4575' data-name='Group 4575'>
						<path
							id='Path_3403'
							data-name='Path 3403'
							d='M14.709,0H11.646A2.527,2.527,0,0,0,9.121,2.524V5.587A3.538,3.538,0,0,1,5.587,9.121H2.524A2.527,2.527,0,0,0,0,11.646v3.063a2.527,2.527,0,0,0,2.524,2.524H5.587a2.527,2.527,0,0,0,2.524-2.524V11.646a3.538,3.538,0,0,1,3.534-3.534h3.063a2.527,2.527,0,0,0,2.524-2.524V2.524A2.527,2.527,0,0,0,14.709,0Z'
							fill='#3b2a82'
						/>
					</g>
				</g>
			</g>
		</svg>
	)
}
